const COMPANY_KNOWLEDGE_ROUSS_CAPITAL = `COMPANY: Rouss Capital Advisors, Inc.
LOCATION: San Jose, California
LICENSE: California Financing Law (CFL) Broker License, DFPI Regulated, $50,000 Surety Bond

ABOUT:
Rouss Capital Advisors is an independent California commercial and consumer loan brokerage serving business owners, real estate investors, and entrepreneurs. The firm is borrower-focused: a broker that works for the borrower, not the lender pipeline.

TAGLINE:
Financing built for the way real businesses actually operate.

FOUNDER:
Judah Rouss — Founder, President, and Responsible Officer

SERVICES:
1. Commercial Real Estate financing (acquisition, refinance, bridge, construction)
2. C&I and Working Capital (term loans, lines of credit, equipment financing)
3. SBA programs (7(a), 504)
4. Bridge and Private Capital

CONTACT:
Phone: (818) 917-9200
Email: judahrouss@gmail.com`;

export default COMPANY_KNOWLEDGE_ROUSS_CAPITAL;
